import graphql from "babel-plugin-relay/macro";

const StockHistoryDetailsQuery = graphql`
query StockHistoryDetailsQuery($stockId:ID){
  stockHistoryDetails(stockId:$stockId)
}
`

export default StockHistoryDetailsQuery
// stockOwnedCount